<div class="app-container" [@fadeInAnimation]="router.url">
    @if (checkingGuards) {
        <div class="checking-guards">
            <div class="guard-text" [translate]="'GLOBAL.LOADING'">Loading</div>
            <div class="loader"></div>
        </div>
    }
    <router-outlet></router-outlet>
</div>
